import React from "react";

const CountdownTimer = ({ setOtherToken, timeInSeconds }: any): JSX.Element => {
  const [seconds, setSeconds] = React.useState(timeInSeconds);

  React.useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      setSeconds(0);
      setOtherToken();
    }
  });

  return (
    <div>
      Não recebi o código. Aguarde 00:{seconds < 10 ? `0${seconds}` : seconds}
    </div>
  );
};

export default CountdownTimer;
